import { createSlice } from "@reduxjs/toolkit";

// prevent everytime login
const initialState = {
  data: [],
  date: "",
  normalDate: "",
  selectedList: "",
  bloodSugarFlag: false,
  submitFlag: true,
  listFlag: false,
};

const bloodSugarSlice = createSlice({
  name: "bloodSugarReducer",
  initialState,
  reducers: {
    setBloodSugarData: (state, action) => {
      state.data = action.payload;
    },
    setInitialDate: (state, action) => {
      state.date = action.payload;
    },
    setNormalDate: (state, action) => {
      state.normalDate = action.payload;
    },
    setSelectedList: (state, action) => {
      state.selectedList = action.payload;
    },
    setBloodSugarFlag: (state, action) => {
      state.bloodSugarFlag = action.payload;
    },
    setBSSubmitFlag: (state, action) => {
      state.submitFlag = action.payload;
    },
    setListFlag: (state, action) => {
      state.listFlag = action.payload;
    },
  },
});

export const {
  setBloodSugarData,
  setInitialDate,
  setNormalDate,
  setSelectedList,
  setBloodSugarFlag,
  setBSSubmitFlag,
  setListFlag,
} = bloodSugarSlice.actions;
export default bloodSugarSlice.reducer;
